import { Component } from '@angular/core';

@Component({
  selector: 'app-tenant-user-edit',
  template: ``,
  styleUrls: []
})
export class TenantUserEditComponent {

}
